import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hide-deliverables',
  templateUrl: './hide-deliverables.component.html',
  styleUrls: ['./hide-deliverables.component.scss']
})
export class HideDeliverablesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
